import { z } from 'zod';

import type { CreateSerieLangRequestViewModel } from '@/shared/api/generated';

/**
 * Schema do formulário de Idioma da Série (criar/editar). Validado por Zod
 * (React Hook Form + resolver).
 *
 * NÃO derivado de `createSerieLangRequestViewModelSchema` (gerado pelo Kubb):
 * aquele schema é exportado com o cast `as unknown as ToZod<...>`, o que torna
 * a shape do `ZodObject` uma ficção de tipo — qualquer `.pick()`/`.extend()`
 * sobre ele degrada o `z.infer` para `never` (mesmo problema documentado em
 * `location/types/countryForm.ts`). Por isso o schema é definido aqui
 * diretamente. `cultureInfo` só é obrigatório na criação — na edição o campo
 * Idioma é exibido como texto fixo (não editável) e não é reenviado.
 */
export const serieLangFormSchema = z.object({
  cultureInfo: z.string().trim().min(1),
  title: z.string().trim().min(1),
  description: z.string(),
  header: z.string(),
});

/**
 * Valores do formulário de Idioma da Série (create/edit).
 *
 * O tipo intersecta com uma asserção nula (no-op) que só permanece `unknown`
 * enquanto `cultureInfo`/`title` continuarem existindo em
 * `CreateSerieLangRequestViewModel` — se um for renomeado/removido no contrato
 * gerado pelo Kubb, a asserção vira `never` e o `yarn type-check` quebra aqui.
 */
export type SerieLangFormValues = z.infer<typeof serieLangFormSchema> &
  ('cultureInfo' | 'title' extends keyof CreateSerieLangRequestViewModel ? unknown : never);
